export default __webpack_public_path__ + "static/media/develop.332edff8.svg";